import { EPackageType } from '@/shared/enum/package-type.enum'
import { shallowRef } from 'vue'
import type { ICtaClick, IItem, IPurchase } from '../interfaces/IAnalytics'
import type { IOffer } from '../interfaces/offer/offer.interface'
import type { IPackage } from '../interfaces/offer/package.interface'
import GA4Service from '@/services/GA4Service'
import GTagCodes from '../constants/GTagCodes'
import type { IBuyStatusOrder } from '../interfaces/buy-status-order.interface'
import { readPackIdFromLocalStorage } from '../utils/pack-info'
import { usePackageStore } from '@/stores/package'

const useAnalytics = () => {
  const impressionsData = shallowRef<IItem[]>([])

  const getPackageType = (pack: IPackage, type: EPackageType) =>
    pack.type & type || pack.packageType! & type

  const sendItemsToAnalytics = (tabs: IOffer[]) => {
    tabs.forEach(({ sliders }) => {
      sliders.forEach(({ packages }) => {
        packages.forEach((p) => {
          const itemName = getPackageType(p, EPackageType.PHONE_CREDIT) ? p.shortName : p.name
          const index = impressionsData.value.length + 1
          const item = {
            index,
            item_name: itemName,
            item_id: p.id,
            price: p.value,
            item_category: p.description,
            quantity: 1
          }
          impressionsData.value.push(item)
        })
      })
    })
    GA4Service.Impressions(impressionsData.value)
    GA4Service.Impressions(impressionsData.value, GTagCodes.claro.gt.dataLayerName)
  }

  const sendPurchaseToAnalytics = (pack: IBuyStatusOrder) => {
    const packageID = readPackIdFromLocalStorage()
    const packageStore = usePackageStore()
    const purchase: IPurchase = {
      id: packageID!,
      name: pack.name,
      folio: pack.folio,
      value: pack.value,
      tax: pack.tax,
      currency: pack.currency,
      category: packageStore.packageSelected?.description!
    }
    GA4Service.Purchase(purchase)
    GA4Service.Purchase(purchase, GTagCodes.claro.gt.dataLayerName)
  }

  const sendAddToCartToAnalytics = (pack: IPackage) => {
    GA4Service.AddToCart({
      id: pack.id,
      name: pack.name,
      value: pack.value,
      category: pack.description
    })
    GA4Service.AddToCart(
      { id: pack.id, name: pack.name, value: pack.value, category: pack.description },
      GTagCodes.claro.gt.dataLayerName
    )
  }

  const sendCtaClickToAnalytics = (ctaClick: ICtaClick) => {
    GA4Service.CtaClick(ctaClick)
    GA4Service.CtaClick(ctaClick, GTagCodes.claro.gt.dataLayerName)
  }

  return {
    sendItemsToAnalytics,
    sendPurchaseToAnalytics,
    sendAddToCartToAnalytics,
    sendCtaClickToAnalytics
  }
}

export default useAnalytics
